import type { ReactNode } from 'react';
import { Empty } from 'antd';
import { cn } from '@shared/lib/cn';

interface EmptyStateProps {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex justify-center py-8', className)}>
      <Empty
        description={
          <div className="flex flex-col items-center gap-2">
            <span className="text-base font-medium">{title}</span>
            {description ? <span className="max-w-md text-sm opacity-70">{description}</span> : null}
            {action ? <div className="pt-2">{action}</div> : null}
          </div>
        }
      />
    </div>
  );
}
